/**
 * Picks the primary signatory from a corporate buyer's signatory list, falling back to the
 * first entry if none is explicitly marked primary (createBuyers always inserts at least one).
 */
export function findPrimarySignatory<T extends {isPrimary: boolean}>(
  signatories: T[] | null | undefined
): T | null {
  if (!signatories || signatories.length === 0) return null;
  return signatories.find(s => s.isPrimary) ?? signatories[0] ?? null;
}
